import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const StatsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #1F4FD8 0%, #1a43b8 50%, #163a9e 100%)' }}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Glowing orbs */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full blur-3xl" style={{ backgroundColor: 'rgba(65, 105, 225, 0.2)' }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {t.stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="mb-2">
                <span className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white group-hover:scale-110 transition-transform inline-block">
                  {stat.value}
                </span>
              </div>
              <p className="text-blue-100 text-sm sm:text-base font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
